import {UI} from "../../stem-core/src/ui/UIBase.js";
import {MessageElement} from "../../blinkpay/widget/ui/MessageElement.jsx";

export function BlinkMakeText(text, options) {
    return <MessageElement message={text} {...options} />;
}
